module.exports = require("core-js-pure/stable/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors.js
// module id = 2858
// module chunks = 25